import { useEffect, useState } from "react";
import * as services from "./../services/customer";

export function useCustomers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    services
      .getCustomers()
      .then((res) => isMounted && setCustomers(res.data.data))
      .catch((err) => console.error(err))
      .finally(() => isMounted && setLoading(false));
    return () => {
      isMounted = false;
    };
  }, []);

  return { customers, loading };
}
